import { render, staticRenderFns } from "./LayoutSlideBar.vue?vue&type=template&id=788f4811&"
import script from "./LayoutSlideBar.vue?vue&type=script&lang=js&"
export * from "./LayoutSlideBar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSlideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports